import { gql } from "@apollo/client";

export const TypeDefinitionSubAttributeFields = gql`
    fragment TypeDefinitionSubAttributeFields on TypeDefinitionAttribute {
        index
        name
        type
        inputType
        disabled
        value
        categories
        dataLoaderConfig {
            dataQueryConfig {
                query
                dataKeyPath
                valueKeyPath
                titleKeyPath
                totalKeyPath
                queryVariables
            }
            valueQueryConfig {
                query
                dataKeyPath
                valueKeyPath
                titleKeyPath
            }
        }
        optionValues {
            name
            value
            translatable
        }
        rules {
            name
            message
            options {
                min
                max
            }
        }
        addOnAttribute {
            index
            name
            multiple
            type
            optionValues {
                name
                value
            }
            value
        }
    }
`;
